var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-picker" }, [
    _c("div", { staticClass: "search-panel" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchText,
            expression: "searchText",
          },
        ],
        attrs: {
          maxlength: "128",
          placeholder: _vm.$t("chatbotv2.typeSearchValue"),
          type: "text",
        },
        domProps: { value: _vm.searchText },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchText = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "attribute-list" }, [
      !_vm.filterAttributes().length
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-center text-center align-items-center mb-5",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.noResultFound")))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attr-select" },
        [
          _vm.filterAttributes("system").length
            ? _c(
                "div",
                {
                  staticClass: "tpl-category-select-category-name",
                  attrs: {
                    "text-color": "lighter",
                    "text-weight": "semi-bold",
                    "text-type": "h5",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("integrations.ticimaxMemberFields")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.filterAttributes("system"), function (attr) {
            return _c(
              "div",
              {
                staticClass: "picker-item",
                class: { active: _vm.defaultSelected === attr.value },
                attrs: {
                  "data-checked": "true",
                  "data-index": "0",
                  "data-item-label": "Name",
                },
                on: {
                  click: function ($event) {
                    return _vm.pick(attr.value)
                  },
                },
              },
              [
                _c("FieldIconPreview", { attrs: { attribute: attr.value } }),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.isLocalizedAttribute(attr.value)
                          ? _vm.$t("ticimax.attributes." + attr.value)
                          : attr.value
                      ) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(attr.placeholder) +
                      "\n                "
                  ),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }